<ng-template #itemTemplate>
  <ng-container *ngIf="ilClasses$ | async as ilClasses; else loadingTemplate">
    <tr *ngFor="let ilClass of ilClasses" [pSelectableRow]="{ license, ilClass }" @fade>
      <td colspan="2">
        <vnm-floated-label-field [label]="ilClass.ilCourse.name">
          <vnm-il-class-sessions-cell [sessions]="ilClass.ilSessions"></vnm-il-class-sessions-cell>
        </vnm-floated-label-field>
      </td>
      <td
        class="p-column-actions"
        [ngClass]="{ 'selection-disabled': ilClass.availableSeats === 0 }"
        [ngStyle]="{ 'vertical-align': 'top' }"
      >
        <vnm-floated-label-field label="il-booking-table-row.seats">
          <span>{{ ilClass.numberOfBookings }} / {{ ilClass.maxCapacity }}</span>
        </vnm-floated-label-field>
      </td>
    </tr>
  </ng-container>
</ng-template>
<ng-template #loadingTemplate>
  <vnm-table-empty-message
    [loading]="true"
    loadingMessage="il-booking-table-row.loading-message"
  ></vnm-table-empty-message>
</ng-template>
